/**
 * Trim and split a typed tag draft on commas, semicolons, or new lines.
 *
 * @param draft - Raw text from the tag input
 * @returns Individual tag names, excluding blanks
 */
export function parseTagDraft(draft: string): string[] {
  if (typeof draft !== 'string' || draft.trim() === '') {
    return []
  }

  return draft
    .split(/[,;\n]/)
    .map(part => part.trim())
    .filter(part => part !== '')
}

/**
 * Append unique tags to a list, ignoring case when detecting duplicates.
 *
 * @param tags - Tags already assigned
 * @param incoming - New tag names to add
 * @returns A new list with any new unique tags appended
 */
export function addTagsToList(tags: string[], incoming: string[]): string[] {
  const next = [...tags]

  incoming.forEach(tag => {
    const name = tag.trim()

    // Skip blanks and names that already exist (case-insensitive)
    if (!name || next.some(existing => existing.toLowerCase() === name.toLowerCase())) {
      return
    }

    next.push(name)
  })

  return next
}

/**
 * Remove the tag at a given index.
 *
 * @param tags - Current tag list
 * @param index - Index to remove
 * @returns A new list without that tag, or the original list when the index is invalid
 */
export function removeTagAtIndex(tags: string[], index: number): string[] {
  if (index < 0 || index >= tags.length) {
    return tags
  }

  return tags.filter((_, tagIndex) => tagIndex !== index)
}
